import * as Flex from "@twilio/flex-ui";
import uhaulStore from "../../CustomRedux/UhaulStore";
import GetLiveChatHeader from "../../LiveChatHeaderHelper";
import ApiService from "./ApiService";

interface UpdateChannelAttributesResponse {
  success: boolean;
}

export default class ProgrammableChatService extends ApiService {
  async updateChannelAttributes(manager: Flex.Manager, channelSid: string, attributes: any): Promise<boolean> {
    try {
      const { success } = await this.#updateChannelAttributes(manager, channelSid, JSON.stringify(attributes));
      return success;
    } catch (error) {
      return false;
    }
  }

  #updateChannelAttributes = async (
    manager: Flex.Manager,
    channelSid: string,
    attributes: any
  ): Promise<UpdateChannelAttributesResponse> => {
    return this.fetchJsonWithReject<UpdateChannelAttributesResponse>(
      `${
        uhaulStore.getState().UhaulReducer.config.liveChatApiUrl
      }/update-conversation-attributes?conversationSid=${encodeURIComponent(channelSid)}&attributes=${encodeURIComponent(attributes)}`,
      {
        method: "post",
        headers: GetLiveChatHeader()
      }
    ).then((response): UpdateChannelAttributesResponse => {
      return {
        ...response
      };
    });
  };
}
